import React from 'react';
import { Button, ButtonProps } from '@mui/material';

interface CustomButtonProps extends ButtonProps {
  children: React.ReactNode;
}

export const CustomButton: React.FC<CustomButtonProps> = ({ children, sx, ...props }) => {
  return (
    <Button
      size="small"
      variant="contained"
      sx={{
        px: 3,
        py: 1,
        ...sx,
      }}
      {...props}
    >
      {children}
    </Button>
  );
};
